<template>
  <div>
    <section class="hero background is-fullheight-with-navbar is-hidden-touch">
      <!-- Desktop + -->
      <div class="hero-body">
        <div class="container hero-container">
          <div class="hero-container-content">
            <div class="mb-6 home-text">
              <h1 class="title hero-title">
                Find where
                you <span class="gym-blue">belong</span>
              </h1>
              <p class="subtitle hero-subtitle">
                Don't ever let your
                <b>location</b> stop you from hitting your <b>goals</b>.
              </p>
            </div>

            <HomeSearch :ranges="ranges" />
          </div>
        </div>
      </div>
    </section>

    <section class="hero background is-hidden-desktop is-hidden-mobile">
      <!-- tablet -->
      <div class="hero-body">
        <div class="columns is-gapless is-mobile pl-1 pr-2">
          <div class="column">
            <h1 class="title hero-title">
              Find where<br />
              you <span class="gym-blue">belong</span>
            </h1>
            <p class="text-1">
              Don't ever let your
              <b>location</b> stop you from hitting your <b>goals</b>.
            </p>
            <div class="search-wrapper mt-2 mb-4">
              <HomeSearch :ranges="ranges" />
            </div>
          </div>
          <div class="column is-7" />
        </div>
      </div>
    </section>

    <section class="hero is-hidden-tablet">
      <!-- mobile -->
      <div class="hero-body background" style="min-height: 70vw;"></div>
      <div class="mobile-search-container">
        <div class="search-wrapper p-4">
          <h1 class="title">
            Find where you <span class="gym-blue">belong</span>
          </h1>
          <HomeSearch :ranges="ranges" class="m-a" />
        </div>
      </div>
    </section>
    <HowItWorksBanner />
    <Testimonials />
    <ActionBanner />
  </div>
</template>

<script>
import HomeSearch from "@/components/molecules/HomeSearch.vue";
import HowItWorksBanner from "@/components/molecules/HowItWorksBanner.vue";
import Testimonials from "@/components/molecules/Testimonials.vue";
import ActionBanner from "@/components/molecules/ActionBanner.vue";
export default {
  components: {
    HomeSearch,
    HowItWorksBanner,
    ActionBanner,
    Testimonials,
  },
  data() {
    return {
      ranges: [1, 5, 10],
    };
  },
};
</script>

<style lang="scss" scoped>

.gym-blue {
  color: #00c5fd;
}

.main-title {
  font-size: calc(3rem + 2vw);
  font-weight: 900;
  color: black;
  margin-bottom: 2rem;
}

.background {
  background-image: url("~@/assets/background_no_dash.png");
  background-repeat: no-repeat;
  background-size: contain;
  overflow: hidden;
}

@media (min-width: 0px) {
  .background {
    background-image: url("~@/assets/background_no_dash.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: right;
  }
  .search-wrapper {
    text-align: center;
  }
}

@media (min-width: 769px) {
  .background {
    background-image: url("~@/assets/MyGymChecker-Image-1.jpg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: right -250px top -20px;
  }
}

@media (min-width: 1024px) {
  .background {
    background-image: url("~@/assets/MyGymChecker-Image-1.jpg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: right -200px top -20px;
  }

  .main-title {
    font-size: calc(2rem + 2vw);
    margin-bottom: 1rem !important;
  }
  .search-wrapper {
    text-align: center;
  }
}

@media (min-width: 1024px) {
  .background {
    background-image: url("~@/assets/MyGymChecker-Image-1.jpg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: right -350px top -20px;
  }

  .main-title {
    font-size: calc(2rem + 2vw);
    margin-bottom: 1rem !important;
  }
  .search-wrapper {
    text-align: center;
  }
}


@media (min-width: 1656px) {
  .background {
    background-image: url("~@/assets/background_no_dash.png");
    background-repeat: no-repeat;
    background-size: auto;
    background-position: right -170px top 0px;
  }

  .main-title {
    font-size: calc(2rem + 2vw);
    margin-bottom: 1rem !important;
  }
  .search-wrapper {
    text-align: center;
  }
}

.main-wrapper-home {
  width: 90%;
  margin: auto;
}

.home-text {
  padding: 0 1rem;
}

.section {
  padding: 3rem 0;
}

.hero-container {
  max-width: 90vw;
  margin: 4rem;
}

.hero-container-content {
  max-width: 40vw;
  padding: 0 1rem;
}

.hero-title {
  font-size: 4rem;
  color: #333333;
}

.title {
color: #333333 !important;
margin-bottom: 1rem !important;
}

.hero-subtitle {
  font-size: 1.75rem;
  color: #333333
}

.mobile-search-container {
  background: white;
}

.flex-center {
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: center;
}
</style>
